import _ from 'lodash';

export function extractConversations ({ conversations, conversationMessages }) {
  const records = conversations.records;
  if (records.length) {
    const recordsCopy = records.map(record => {
      record.messages = conversationMessages.byConversationId[record.conversation_id].data;
      return record;
    });
    const recordsCopyWithMessages = recordsCopy.filter(record => record.messages.length);
    return recordsCopyWithMessages.map(processConversationRecord);
  }
  return records;
}

/**
 *
 * @param {Object} state
 * @param {Object} state.conversations
 * @param {Object} state.conversationMessages
 * @param {Number} id
 * @return {Object} - conversation record with all loaded messages
 */
export function extractConversationWithMessagesById ({ conversations, conversationMessages }, id) {
  const record = _.find(conversations.records, ['conversation_id', id]);

  if (record) {
    const recordCopy = { ...record };

    recordCopy.messages = conversationMessages.byConversationId[id];

    return processConversationRecord(recordCopy);
  }
}

/**
 *
 * @param {Object} conversation
 * @return {Object} - a copy of conversation record with additional data for rendering
 */
function processConversationRecord (conversation) {
  const record = { ...conversation };
  const {
    first_name,
    last_name,
    photo_image_url
  } = record.participants[0];

  record.title = `${first_name} ${last_name}`;
  record.lastMessagePreview = record.messages[record.messages.length - 1];
  record.image = photo_image_url;

  return record;
}



// WEBPACK FOOTER //
// ./src/helpers/conversations.js